// CRITICAL: Import React first to ensure it's in the entry bundle
// This prevents "Cannot read properties of undefined" errors in code-split chunks
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import '../styles/index.css'
import { register as registerServiceWorker } from '@/lib/services/serviceWorkerRegistration'

// Ensure React is available globally before any lazy-loaded chunks execute
(window as any).React = React;

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker for PWA features (offline support, caching)
registerServiceWorker();
